<template>
  <div class="loading-spinner"></div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
  .loading-spinner {
    height: 3rem;
    margin-top: 3rem;

    &::before {
      transition: opacity 0.2s ease;
      content: "\f1ce";
      font-family: 'FontAwesome';
      animation: fa-spin 2s infinite linear;
      font-size: 2.5rem;
      color: #ccc;
      position: absolute;
    }
  }
</style>
